import { useMemo } from "react";
import { StreamingHelper } from "@scrile/streaming-client/build";

export default function useWebRTC({ consumerOnAllStreamClosed }: { consumerOnAllStreamClosed?: () => void } = {}) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => new StreamingHelper({ consumerOnAllStreamClosed }), []);
}
